import { useEffect, useMemo, useState } from 'react';
import { useRowSelection } from './useRowSelection';

export const useFullRowSelection = <RowData>(data: RowData[] | undefined, uniqueRowId = 'id' as keyof RowData) => {
    const selection = useRowSelection();
    const [selectedRowsDataMap, setSelectedRowsDataMap] = useState(new Map<string, RowData>());
    useEffect(() => {
        if (data === undefined) {
            return;
        }
        setSelectedRowsDataMap((oldSelectedRowsDataMap) => {
            const newSelectedRowsDataMap = new Map(oldSelectedRowsDataMap);
            Object.keys(selection.rowSelection).forEach((id) => {
                const rowData = data.find((row) => id === row[uniqueRowId]);
                if (rowData) {
                    newSelectedRowsDataMap.set(id, rowData);
                }
            });
            newSelectedRowsDataMap.forEach((row) => {
                if (!selection.rowSelection[row[uniqueRowId] as string]) {
                    newSelectedRowsDataMap.delete(row[uniqueRowId] as string);
                }
            });

            return newSelectedRowsDataMap;
        });
    }, [data, selection.rowSelection, uniqueRowId]);
    const selectedRowsData = useMemo(() => [...selectedRowsDataMap].map((entry) => entry[1]), [selectedRowsDataMap]);

    return {
        ...selection,
        selectedRowsData,
    };
};
